/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AddFinancialPeriodRequest {
  noteId: string
  periodType: AddFinancialPeriodRequestPeriodTypeEnum
}

export const AddFinancialPeriodRequestPeriodTypeEnum = {
  PREVISIONNEL: "PREVISIONNEL",
  ANTERIEUR: "ANTERIEUR",
  INTERMEDIAIRE: "INTERMEDIAIRE"
} as const

export type AddFinancialPeriodRequestPeriodTypeEnum =
  (typeof AddFinancialPeriodRequestPeriodTypeEnum)[keyof typeof AddFinancialPeriodRequestPeriodTypeEnum]
